function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "lodash";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { clearSearch, filterByCategory, getRecordedCategories, search } from "@common/actions";
import { parseQuery } from "@common/services/helpers";
import { CATEGORIES_ALL_ID, FILTER_TYPE_RECORDED, ROUTE_SEARCH, SEARCH_DEBOUNCE_TIME, SEARCH_MODES, SEARCH_MODE_DEFAULT_ID, SEARCH_TYPE_ACTIVE } from "@config/constants";
import { withRouter } from "react-router-dom";
import CategoryFilters from "./CategoryFilters";
export var SearchBar = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(SearchBar, PureComponent);
    var _super = _create_super(SearchBar);
    function SearchBar(props) {
        _class_call_check(this, SearchBar);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            searchString: "",
            selectedCategory: CATEGORIES_ALL_ID,
            isFilterOpened: false,
            selectedSearchMode: SEARCH_MODES.find(function(param) {
                var id = param.id;
                return id === SEARCH_MODE_DEFAULT_ID;
            })
        };
        _this.pushTimeout = null;
        _this.onChange = _this.onChange.bind(_assert_this_initialized(_this));
        _this.onCategoryFilterChange = _this.onCategoryFilterChange.bind(_assert_this_initialized(_this));
        _this.doSearch = _this.doSearch.bind(_assert_this_initialized(_this));
        _this.pushSearchState = _this.pushSearchState.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(SearchBar, [
        {
            /**
     * Handle the input value change.
     * @param {Object} event
     */ key: "onChange",
            value: function onChange(param) {
                var _this = this;
                var value = param.target.value;
                this.setState({
                    searchString: value
                }, function() {
                    return _this.pushSearchState(true);
                });
            }
        },
        {
            /**
     * Trigger data fetching or clearing
     * the results if no query is provided.
     */ key: "doSearch",
            value: function doSearch(props) {
                var _$clearSearch = props.clearSearch, location1 = props.location, _$search = props.search;
                var _parseQuery = parseQuery(location1.search), query = _parseQuery.query, mode = _parseQuery.mode, type = _parseQuery.type;
                if (query) {
                    _$search("".concat(ROUTE_SEARCH, "?query=").concat(query, "&mode=").concat(mode), type);
                } else {
                    _$clearSearch(false);
                }
            }
        },
        {
            /**
     * Renders the search container.
     * @returns {ReactElement || null}
     */ key: "renderSearchInput",
            value: function renderSearchInput() {
                var _this_state = this.state, isFilterOpened = _this_state.isFilterOpened, searchString = _this_state.searchString, selectedSearchMode = _this_state.selectedSearchMode;
                var i18n = this.props.i18n;
                var label = SEARCH_MODES.find(function(param) {
                    var id = param.id;
                    return id === selectedSearchMode.id;
                }).label;
                return /*#__PURE__*/ _jsx("div", {
                    className: "search-and-filters",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "search-container",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "icon icon-search"
                            }),
                            /*#__PURE__*/ _jsx("input", {
                                className: "search-field",
                                type: "text",
                                placeholder: i18n.search.placeholder,
                                value: searchString,
                                onChange: this.onChange
                            })
                        ]
                    })
                });
            }
        },
        {
            /**
     * Handles the change of the category filter.
     * Triggers result filtering.
     * @param filter
     */ key: "onCategoryFilterChange",
            value: function onCategoryFilterChange(filter) {
                this.setState({
                    selectedCategory: filter || CATEGORIES_ALL_ID
                });
                this.props.filterByCategory(filter, FILTER_TYPE_RECORDED);
            }
        },
        {
            /**
     * Push search state with debounce or not
     * @param debounce {boolean}
     */ key: "pushSearchState",
            value: function pushSearchState(debounce) {
                var _this_state = this.state, searchString = _this_state.searchString, selectedSearchMode = _this_state.selectedSearchMode;
                var history = this.props.history;
                var trimmedSearchString = searchString.trim();
                var encodedSearchString = encodeURIComponent(trimmedSearchString);
                var isInDoubleQuotes = trimmedSearchString.charAt(0) === '"' && trimmedSearchString.charAt(trimmedSearchString.length - 1) === '"';
                // Set the search type to active if
                // the search string is in double quotes.
                if (isInDoubleQuotes) {
                    encodedSearchString += "&type=".concat(SEARCH_TYPE_ACTIVE);
                }
                this.setState({
                    selectedCategory: CATEGORIES_ALL_ID
                });
                if (debounce) {
                    // Navigate to the same route. This will trigger
                    // fetching new results with debounce
                    clearTimeout(this.pushTimeout);
                    this.pushTimeout = setTimeout(function() {
                        history.push("".concat(ROUTE_SEARCH, "?query=").concat(encodedSearchString, "&mode=").concat(selectedSearchMode.id));
                    }, SEARCH_DEBOUNCE_TIME);
                } else {
                    history.push("".concat(ROUTE_SEARCH, "?query=").concat(encodedSearchString, "&mode=").concat(selectedSearchMode.id));
                }
            }
        },
        {
            // TODO uncomment when BE implements logic
            /*/!**
     * Closes the filter on clicking outside of it.
     * @param target
     *!/
    closeOnOutsideClick({ target }) {
        if (!this.searchFilterOptionsElement.contains(target) && !this.filterSwitch.contains(target)) {
            this.setState({ isFilterOpened: false });
        }
    }

    /!**
     * Toggles the search filter.
     *!/
      toggleSearchFilter() {
          this.setState(prevState => ({ isFilterOpened: !prevState.isFilterOpened }));
      }

    /!**
     * Sets a new search filter.
     * @param {number} filterId
     *!/
    changeSearchFilter(filterId) {
         this.setState({
             isFilterOpened: false,
             selectedSearchMode: SEARCH_MODES.find(({ id }) => id === filterId)
         });

         this.pushSearchState(false);
     }*/ key: "render",
            value: function render() {
                var template = null;
                var selectedCategory = this.state.selectedCategory;
                var _this_props = this.props, i18n = _this_props.i18n, liveChannels = _this_props.liveChannels, location1 = _this_props.location, screenType = _this_props.screenType, recorded = _this_props.recorded, searchState = _this_props.searchState, playerIsOpen = _this_props.playerIsOpen, isCategoriesFilterOpen = _this_props.isCategoriesFilterOpen, closeCategoryFilter = _this_props.closeCategoryFilter, toggleCategoryFilter = _this_props.toggleCategoryFilter;
                var type = parseQuery(location1.search).type;
                var representedCategories = searchState.representedCategories, representedRecordedCategories = searchState.representedRecordedCategories;
                var categories = recorded.categories;
                var areChannelsReady = Object.keys(liveChannels).length > 0;
                var areCategoriesReady = Object.keys(categories).length > 0;
                if (!isEmpty(this.props.i18n) || areChannelsReady || areCategoriesReady) {
                    template = /*#__PURE__*/ _jsxs("div", {
                        className: "search-bar-component".concat(playerIsOpen ? " hide" : ""),
                        children: [
                            this.renderSearchInput(),
                            /*#__PURE__*/ _jsx(CategoryFilters, {
                                i18n: i18n,
                                categories: categories,
                                filterType: FILTER_TYPE_RECORDED,
                                screenType: screenType,
                                representedCategories: type === SEARCH_TYPE_ACTIVE ? representedCategories : representedRecordedCategories,
                                onChange: this.onCategoryFilterChange,
                                selectedCategoryId: selectedCategory,
                                isCategoriesFilterOpen: isCategoriesFilterOpen,
                                closeCategoryFilter: closeCategoryFilter,
                                toggleCategoryFilter: toggleCategoryFilter
                            })
                        ]
                    });
                }
                return template;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this_props = this.props, _$getRecordedCategories = _this_props.getRecordedCategories, location1 = _this_props.location;
                var _parseQuery = parseQuery(location1.search), query = _parseQuery.query, mode = _parseQuery.mode;
                var searchString = decodeURIComponent(query || "");
                // TODO uncomment when BE implements logic
                // const selectedSearchMode = SEARCH_MODES.find(({ id }) => id === +mode);
                /*this.setState(prevState => ({
            searchString,
            selectedSearchMode: selectedSearchMode || prevState.selectedSearchMode
        }));*/ // TODO delete when BE implements logic
                this.setState({
                    searchString: searchString
                });
                this.doSearch(this.props);
                // TODO uncomment when BE implements logic
                // document.addEventListener('click', this.closeOnOutsideClick, false);
                _$getRecordedCategories();
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                var location1 = this.props.location;
                var hasNewQueryParams = location1.search && location1.search !== nextProps.location.search;
                if (hasNewQueryParams) {
                    var query = parseQuery(nextProps.location.search).query;
                    this.setState({
                        searchString: decodeURIComponent(query)
                    });
                    this.doSearch(nextProps);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                var _this_props_searchState = this.props.searchState, future = _this_props_searchState.future, recorded = _this_props_searchState.recorded, representedCategories = _this_props_searchState.representedCategories;
                var _prevProps_searchState = prevProps.searchState, prevFuture = _prevProps_searchState.future, prevRecorded = _prevProps_searchState.recorded;
                var type = parseQuery(location.search).type;
                // On new active set the major category, but only if
                // there is only one represented category.
                if (type === SEARCH_TYPE_ACTIVE && (prevFuture !== future || prevRecorded !== recorded)) {
                    var selectedCategory = CATEGORIES_ALL_ID;
                    if (future.length > 0 && representedCategories.size === 1) {
                        selectedCategory = future[0].majorId;
                    } else if (recorded.length > 0 && representedCategories.size === 1) {
                        selectedCategory = recorded[0].majorId;
                    }
                    this.setState({
                        selectedCategory: selectedCategory
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.clearSearch(false);
                clearTimeout(this.pushTimeout);
            // TODO uncomment when BE implements logic
            // document.removeEventListener('click', this.closeOnOutsideClick, false);
            }
        }
    ]);
    return SearchBar;
}(PureComponent);
var mapStateToProps = function(param) {
    var liveChannels = param.liveChannels, logos = param.logos, screenType = param.screenType, recorded = param.recorded, searchState = param.searchState;
    return {
        liveChannels: liveChannels,
        logos: logos,
        recorded: recorded,
        searchState: searchState,
        screenType: screenType
    };
};
export default withRouter(connect(mapStateToProps, {
    clearSearch: clearSearch,
    filterByCategory: filterByCategory,
    getRecordedCategories: getRecordedCategories,
    search: search
})(SearchBar));
